// Port of Sheet from prototype/components/core/Panel.jsx (design D3/D11): same
// name, same prop contract (prototype/components/core/Panel.d.ts's SheetProps),
// styled only from token CSS vars. UI.md §7 groups `Panel`/`Sheet` as one kit
// component pair (they ship from a single kit file), but `design.md`'s module
// layout ports Sheet as its own client module — the bee-type editor's bottom
// drawer with grab handle (UI.md §2 "Bottom sheets round top corners only and
// carry a grab handle").
//
// Fix vs. the kit source (task 6.2): the kit's close button is a fixed 36x36px
// square, below the design system's normative ≥44px hit target (UI.md §2, "≥ 44
// px hit targets everywhere"). Ported at 44x44 here and mirrored back into
// `prototype/components/core/Panel.jsx`'s `Sheet` export in the same change (the
// CLAUDE.md/prototype/CLAUDE.md sync contract: an app-side fix to shipped UI
// updates the matching kit artifact).

import type { CSSProperties, ReactNode } from 'react';

export interface SheetProps {
  title?: string;
  onClose?: () => void;
  children?: ReactNode;
  style?: CSSProperties;
}

export function Sheet({ title, onClose, children, style }: SheetProps) {
  return (
    <div
      data-ui="sheet"
      style={{
        background: 'var(--surface-app)',
        borderRadius: 'var(--r-lg) var(--r-lg) 0 0',
        boxShadow: 'var(--shadow-sheet)',
        padding: 'var(--sp-4)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--sp-3)',
        ...style,
      }}
    >
      <div
        style={{
          width: 40,
          height: 4,
          borderRadius: 2,
          background: 'var(--line-strong)',
          margin: '0 auto',
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 600,
            fontSize: 'var(--text-xl)',
            color: 'var(--ink-1)',
          }}
        >
          {title}
        </div>
        {onClose && (
          <button
            type="button"
            data-ui="icon-button"
            title="Close"
            onClick={onClose}
            style={{
              width: 44,
              height: 44,
              borderRadius: 22,
              border: '1px solid var(--line-strong)',
              background: 'var(--surface-card)',
              color: 'var(--ink-2)',
              fontSize: 16,
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
